import { Combobox } from '@lumapps/lumx/react';

/** When to show the search combobox shortcuts */
export const useHasShortcuts = () => {
    const optionsState = Combobox.useComboboxEvent('optionsChange', undefined);
    return Boolean(optionsState?.optionsLength);
};
